var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWeatherHail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.29 11.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #667085;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-width: 1.5px;\n      }\n\n      .cls-2 {\n        stroke: #667185;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.54,8.95c1.66,0,3-1.34,3-3s-1.34-3-3-3c-.19,0-.38.02-.56.06-.33-1.29-1.5-2.25-2.9-2.25s-2.56.95-2.89,2.24c-.14-.02-.29-.04-.44-.04-1.66,0-3,1.34-3,3,0,1.45,1.03,2.66,2.4,2.94.2.04,7.18.06,7.39.06"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.42,
    y1: 11.12,
    x2: 8.42,
    y2: 11.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.97,
    y1: 11.12,
    x2: 10.97,
    y2: 11.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.87,
    y1: 11.12,
    x2: 5.87,
    y2: 11.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.32,
    y1: 11.12,
    x2: 3.32,
    y2: 11.15
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherHail);
export default __webpack_public_path__ + "static/media/icon_weather_hail.06635fae1a1bf81e2141e967693c73b1.svg";
export { ForwardRef as ReactComponent };